<template>
    <svg
        width="7"
        height="11"
        viewBox="0 0 7 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.73075 5.3396L5.804 9.4126C5.94233 9.5511 6.01317 9.72519 6.0165 9.93485C6.01967 10.1444 5.94883 10.3216 5.804 10.4666C5.659 10.6114 5.48333 10.6839 5.277 10.6839C5.07067 10.6839 4.895 10.6114 4.75 10.4666L0.25575 5.97235C0.16225 5.87869 0.0962499 5.77994 0.0577499 5.6761C0.0192499 5.57227 0 5.4601 0 5.3396C0 5.2191 0.0192499 5.10694 0.0577499 5.0031C0.0962499 4.89927 0.16225 4.80052 0.25575 4.70685L4.75 0.212602C4.8885 0.0742683 5.06258 0.00343497 5.27225 0.000101633C5.48175 -0.00306503 5.659 0.0677683 5.804 0.212602C5.94883 0.357602 6.02125 0.533269 6.02125 0.739602C6.02125 0.945935 5.94883 1.1216 5.804 1.2666L1.73075 5.3396Z"
            fill="currentColor"
        />
    </svg>
</template>
